var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form",
    {
      ref: "form",
      staticClass: "menus_nav_config",
      attrs: {
        disabled: _vm.disabled,
        model: _vm.value.config,
        "label-width": "80px",
        "label-suffix": "：",
        "hide-required-asterisk": "",
      },
    },
    [
      _c("div", { staticClass: "label title" }, [
        _c("div", [
          _vm._v(" 设置分类及排序 "),
          _c("span", { staticClass: "tips" }, [
            _vm._v("（拖动分类可调整排序）"),
          ]),
        ]),
      ]),
      _c(
        "draggable",
        {
          attrs: { animation: "500", "force-fallback": true },
          model: {
            value: _vm.value.config.value,
            callback: function ($$v) {
              _vm.$set(_vm.value.config, "value", $$v)
            },
            expression: "value.config.value",
          },
        },
        _vm._l(_vm.value.config.value, function (item, index) {
          return _c(
            "div",
            { key: index, staticClass: "box" },
            [
              _c("div", { staticClass: "header" }, [
                _vm.value.config.value.length > 1
                  ? _c("i", {
                      staticClass: "el-icon el-icon-delete",
                      on: {
                        click: function ($event) {
                          return _vm.deleteCategory(index)
                        },
                      },
                    })
                  : _vm._e(),
              ]),
              _c(
                "el-form-item",
                {
                  attrs: {
                    label: "关联菜单",
                    prop: "value." + index + ".id",
                    rules: [
                      {
                        required: true,
                        message: "请选择关联菜单",
                      },
                    ],
                  },
                },
                [
                  _c("el-cascader", {
                    staticStyle: { width: "100%" },
                    attrs: {
                      options: _vm.menuList,
                      props: {
                        label: "show_name",
                        value: "id",
                        children: "childrens",
                        checkStrictly: true,
                        emitPath: false,
                      },
                      filterable: "",
                      placeholder: "选择菜单",
                    },
                    on: {
                      change: function (menusid) {
                        return _vm.changeID(item, { menusid: menusid })
                      },
                    },
                    model: {
                      value: item.id,
                      callback: function ($$v) {
                        _vm.$set(item, "id", $$v)
                      },
                      expression: "item.id",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  attrs: {
                    prop: "value." + index + ".name",
                    rules: [
                      {
                        required: true,
                        message: "请输入展示名称",
                      },
                    ],
                    label: "展示为",
                  },
                },
                [
                  _c("el-input", {
                    attrs: {
                      maxlength: "8",
                      minlength: "1",
                      clearable: "",
                      placeholder: "请输入",
                    },
                    model: {
                      value: item.name,
                      callback: function ($$v) {
                        _vm.$set(item, "name", $$v)
                      },
                      expression: "item.name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        }),
        0
      ),
      _c(
        "el-button",
        {
          staticClass: "el-icon-plus",
          staticStyle: { width: "100%" },
          attrs: { type: "primary" },
          on: { click: _vm.addCategory },
        },
        [_vm._v(" 添加分类")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }